export default __webpack_public_path__ + "static/bg-buzz-5e386bcc18d4956b4a03293078a1f8b3.png";